/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import { SimTypography } from 'components/SimTypography';

import BGFECares from 'assets/images/BGFECares.png';

const FeaturesCares = () => {
	const theme = useTheme();

	const LeftSide = () => (
		<Box>
			<Box>
				<SimTypography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
					SimSouls{' '}
					<Box component={'span'} color={theme.palette.secondary.main}>
						CARES
					</Box>
				</SimTypography>

				<SimTypography color={theme.palette.secondary.main} variant={'h6'}>
					Nannies | Counsel | Daycare | Camps | Schools | Group Living Facilities
				</SimTypography>

				<Box marginTop={4}>
					<SimTypography variant='h6' color='text.secondary'>
						Simsouls CARES to help them carry their remarkable treasure with strength and dignity. Raising a
						child with special needs is both a gift and a responsibility. Due to high divorce rate, single
						mothers assume the exhausting responsibility of being both a financial & care provider with
						little to no support. Today’s ecosystem of nannies, daycares, summer camps, schools & group
						living facilities cater well to the needs of neurotypical children, leaving neuro diverse
						children & single mothers with the insurmountable challenge.
					</SimTypography>
				</Box>

				<Box marginTop={2}>
					<SimTypography variant='h6' color={theme.palette.secondary.main}>
						IT TAKES A VILLAGE TO RAISE A CHILD WITH SPECIAL NEEDS.
					</SimTypography>
				</Box>

				<Box marginTop={2}>
					<SimTypography color='text.secondary' variant='h6'>
						SimSouls was founded to reimagine & build an ecosystem to allow every neuro diverse child &
						their parents to live a full life.
						<Box component={'span'} color={theme.palette.primary.main}>
							Explore SimSouls CARE Support ecosystem{' '}
						</Box>
						that holistically serves the needs of special needs community from birth till death.
					</SimTypography>
				</Box>
			</Box>
		</Box>
	);
	return (
		<Box>
			<Box>
				<Grid container spacing={0} backgroundColor={'transparent'}>
					<Grid item xs={12} lg={12}>
						<Box display={'flex'} flexDirection={'column'}>
							<Box
								sx={{
									backgroundImage: { xs: `url(${BGFECares})` },
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'right',
									backgroundSize: 'contain'
								}}>
								<Box
									width={1}
									sx={{
										backgroundImage: {
											xs: `linear-gradient(90deg, ${theme.palette.background.default} , ${alpha(
												theme.palette.background.default,
												0.7
											)} 100%)`,
											sm: `linear-gradient(90deg, ${theme.palette.background.default} 35%, transparent 65%)`
										},
										backgroundRepeat: 'no-repeat',
										backgroundPosition: 'right',
										backgroundSize: 'contain'
									}}>
									<Box
										width={{ sm: '50%', lg: '50%' }}
										paddingRight={4}
										paddingLeft={{ xs: 3, lg: 12 }}
										paddingY={2}>
										<LeftSide />
									</Box>
								</Box>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
};

export { FeaturesCares };
